module.exports = __webpack_public_path__ + "img/g6.ac854158.png";